'use strict';

import PayrollComponent from './payroll/PayrollComponent.service'
import PositionAllowance from './payroll/PositionAllowance.service'
import SalarySetting from './payroll/SalarySetting.service'
import Membership from './payroll/Membership.service'
import Period from './payroll/Period.service'
import PayrollSummary from './payroll/PayrollSummary.service'
import Others from './payroll/Other.service'
import TaxMethod from './payroll/TaxMethod.service'
import TaxStatus from './payroll/TaxStatus.service'
import PayrollAccessControl from './payroll/PayrollAceessControl.service'

const state = {
  periodId: null,
  status: 0,
  companyName: null,
  companyId: null,
}

const actions = {
  ...PayrollComponent.actions,
  ...PositionAllowance.actions,
  ...SalarySetting.actions,
  ...Membership.actions,
  ...Period.actions,
  ...PayrollSummary.actions,
  ...Others.actions,
  ...TaxMethod.actions,
  ...TaxStatus.actions,
  ...PayrollAccessControl.actions,
  setPeriodId(context, payload) {
    context.commit('setPeriodId', payload)
  },
  setStatusId(context, payload) {
    context.commit('setStatusId', payload)
  },
  setCompanyName(context, payload) {
    context.commit('setCompanyName', payload)
  },
  setCompanyId(context, payload) {
    context.commit('setCompanyId', payload)
  },
}

const mutations = {
  setPeriodId({ payroll }, payload) {
    payroll.periodId = payload
  },
  setStatusId({ payroll }, payload) {
    payroll.status = payload
  },
  setCompanyName({ payroll }, payload) {
    payroll.companyName = payload
  },
  setCompanyId({ payroll }, payload) {
    payroll.companyId = payload
  },
}

const getters = {
  pGetData: ({ payroll }) => (feature, key = null) => {
    const state = payroll
    if (key) {
      if (state) if (state[feature]) if (state[feature][key]) return state[feature][key]
    } else {
      if (state) if (state[feature]) return state[feature]
    }
    return null
  },
  pGetAll: ({ payroll }) => {
    return payroll
  },
  pGetAllKeys: ({ payroll }) => {
    return Object.keys(payroll)
  },
}

export default { getters, actions, mutations, state }